import { Chip, Icon, Link, Typography } from '@material-ui/core'
import { makeStyles, MuiThemeProvider, useTheme } from '@material-ui/core/styles'
import { Check, ExitToApp } from '@material-ui/icons'
import MaterialTable, { MTableCell } from '@material-table/core'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { getChipStyles } from '../../services/helpers'
import { table } from '../../services/theme'
import { BOARDING, COMPATIBILITY_SESSION, getIconAndTagByFoundingAndMembership, TRAINING_CLASS } from '../../utils'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '24px 25px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	membershipWrapper: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	membershipIcon: {
		color: '#6B4AD6',
		'&::before': {
			fontSize: '14px',
			lineHeight: '14px'
		}
	},
	membershipType: {
		fontFamily: 'Nunito',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '19px',
		color: '#777679',
		textTransform: 'capitalize'
	}
}))

export const VisitsTable = (props) => {
	const classes = useStyles()
	const theme = useTheme()
	const history = useHistory()
	const { tableRef } = props

	const facilities = useSelector((state) => state.specific.facilities.facilities)
	const visitsLoading = useSelector((state) => state.specific.visits.loading)
	const [loading, setLoading] = useState(true)

	let { visits } = props

	useEffect(() => {
		if (!visits || visitsLoading) {
			setLoading(true)
		} else {
			setLoading(false)
		}
	}, [visits, visitsLoading])

	const renderDates = (data) => (
		<Typography variant="body2">
			{data.startDate && data.endDate && (data.type === BOARDING || data.type === TRAINING_CLASS)
				? `${moment(data.startDate).format('MMM DD')} - ${moment(data.endDate).format('MMM DD, YYYY')}`
				: moment(data.startDate).format('MMM DD YYYY')}
		</Typography>
	)

	const renderBlock = (data) => {
		if (data.time_block)
			return (
				<Typography variant="body2" style={{ textTransform: 'capitalize' }}>
					{data.time_block}
				</Typography>
			)
		return null
	}

	const BAD_STATI = [7, 8]

	const renderPets = (data, classes) => {
		return (
			<div>
				{data.pets && data.pets.length > 0
					? data.pets.map((pet, i) =>
							!pet._id ? (
								<Typography key={i}>Pet not found</Typography>
							) : (
								<div
									key={pet._id}
									style={{
										display: 'flex',
										alignItems: 'center',
										position: 'relative',
										paddingLeft: 32
									}}>
									{pet.status && pet.status.checked_in ? (
										<Check
											className={classes.petStatusIcon}
											style={{
												fill: '#4CAF50',
												height: 16,
												strokeWidth: 3,
												stroke: '#4CAF50'
											}}
										/>
									) : pet.status && pet.status.checked_in === false ? (
										<ExitToApp
											className={classes.petStatusIcon}
											style={{
												fill: '#777679',
												height: 16,
												strokeWidth: 1,
												stroke: '#777679'
											}}
										/>
									) : null}
									<Link
										component={RouterLink}
										style={{
											color: '#1A1A35'
										}}
										onClick={(e) => e.stopPropagation()}
										to={`/clients/${data.household._id}/pets/${pet._id}`}>
										{pet.name}
									</Link>
									{data?.welcome_day_pets?.includes(pet._id) &&
										!BAD_STATI.includes(data?.status?.id) && (
											<Icon
												className="fa fa-calendar"
												style={{ fontSize: 14, color: '#6B4AD6', marginLeft: 8 }}
											/>
										)}
								</div>
							)
					  )
					: null}
			</div>
		)
	}

	const handleAppRightClick = (e, prms) => {
		e.preventDefault()
		let url = `/clients/${prms.household_id}/appointments/${prms._id}${`?date=${prms.date}`}`
		if (prms.type === TRAINING_CLASS) {
			url = `/facilities/${prms.facility_id}/training/class/${prms.training_class_id}/enrollment/${prms.training_enrollment_id}`
		}
		const win = window.open(url, '_blank')
		win.focus()
	}

	const renderAppointment = (data) => {
		let date = moment()
		let start = moment(data.startDate)
		let end = moment(data.endDate)
		let isStart = start.isSame(date, 'day')
		let isEnd = end.isSame(date, 'day')

		const formattedDate = moment(date).format('YYYYMMDD')
		const appPrms = {
			_id: data._id,
			household_id: data.household_id,
			date: formattedDate,
			type: data.type,
			facility_id: data.facility_id,
			training_class_id: data.training_class_id || '',
			training_enrollment_id: data.training_enrollment_id || ''
		}
		let label = data.type
		if (data.type === COMPATIBILITY_SESSION) {
			label = 'Compatibility Session'
		}
		if (data.type === TRAINING_CLASS) {
			label = 'Training Class'
		}
		if (data.type === 'addon_only') {
			label = 'Enrichment Only'
		}
		return (
			<div onContextMenu={(e) => handleAppRightClick(e, appPrms)}>
				<Typography
					style={{
						textTransform: 'capitalize',
						color: '#6B4AD6',
						fontWeight: 800,
						fontSize: '16px',
						lineHeight: '22px'
					}}>
					{label}
				</Typography>
				{isStart && data.type === BOARDING ? <Typography variant="body2">Arrival</Typography> : null}
				{isEnd && data.type === BOARDING ? <Typography variant="body2">Departure</Typography> : null}
				{data.type === TRAINING_CLASS ? (
					<Typography variant="body2">{data?.training_course?.name || ''}</Typography>
				) : null}
			</div>
		)
	}

	const renderClientName = (data) => {
		if (data.household && data.household.accounts) {
			const account = data.household.accounts.find((a) => a.primary)
			const [iconName, iconColor, tag] = getIconAndTagByFoundingAndMembership(data.household)

			return (
				<div>
					<Link
						component={RouterLink}
						style={{
							color: theme.palette.secondary.main,
							marginBottom: 5,
							fontSize: '14px',
							lineHeight: '19px'
						}}
						onClick={(e) => e.stopPropagation()}
						to={`/clients/${data.household._id}/contacts`}>
						{account ? account.full_name : 'No name'}
					</Link>
					{!!iconName || !!tag ? (
						<div className={classes.membershipWrapper}>
							{!!iconName && (
								<Icon
									className={`fa fa-${iconName}`}
									style={{
										color: iconColor,
										fontWeight: '900',
										fontSize: '14px',
										lineHeight: '16px',
										width: 20
									}}
								/>
							)}
							<Typography className={classes.membershipType}>{tag}</Typography>
						</div>
					) : null}
				</div>
			)
		}

		return 'No client'
	}

	const renderLocation = (data) => {
		let facility = facilities && facilities.length && facilities.find((f) => f._id === data.facility_id)

		return facility && facility.name ? <Typography variant="body2">{facility.name}</Typography> : null
	}

	return (
		<MuiThemeProvider theme={table}>
			<MaterialTable
				tableRef={tableRef}
				options={{
					toolbar: false,
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2',
						backgroundColor: '#F9F9F9'
					},
					rowStyle: {
						verticalAlign: 'top',
						width: '100%'
					},
					pageSize: 10,
					pageSizeOptions: [10, 20, 50],
					toolbarButtonAlignment: 'left',
					searchFieldAlignment: 'left',
					searchFieldVariant: 'filled'
				}}
				isLoading={loading}
				columns={[
					{ title: 'Dates', render: (data) => renderDates(data, classes) },
					{ title: 'Time Block', render: (data) => renderBlock(data, classes) },
					{
						title: 'Appointment',
						field: 'type',
						render: (data) => renderAppointment(data)
					},
					{
						title: 'Client',
						render: (data) => renderClientName(data),
						customFilterAndSearch: (value, rowData) => {
							let { household } = rowData
							let account = household.account || household.accounts.find((a) => a.primary)
							let name = value
							if (name) name = name.toUpperCase()
							return account ? account.full_name.toUpperCase().includes(name.toUpperCase()) : false
						}
					},
					{
						title: 'Pet(s)',
						field: 'pets',
						render: (data) => renderPets(data, classes),
						customFilterAndSearch: (value, rowData) => {
							let { pets } = rowData
							let name = value
							if (name) name = name.toUpperCase()
							return pets && pets.length > 0
								? pets.findIndex((pet) => pet.name.toUpperCase().includes(name)) !== -1
								: false
						}
					},
					{
						title: 'Location',
						render: (data) => renderLocation(data),
						customFilterAndSearch: (value, rowData) => {
							let facility =
								facilities &&
								facilities.length &&
								facilities.find((f) => f._id === rowData.facility_id)

							return facility && facility.name
								? facility.name.toUpperCase().includes(value.toUpperCase())
								: null
						}
					},
					{
						title: 'Status',
						field: 'status.name',
						render: (data) => {
							return (
								<Chip
									label={data.status ? data.status.name : 'No Status'}
									style={data.status ? getChipStyles(data.status.name) : null}
								/>
							)
						}
					}
				]}
				data={visits || []}
				onRowClick={(e, visit) => {
					const { type, household_id, _id, training_class_id, facility_id, training_enrollment_id } =
						visit
					if (type === TRAINING_CLASS) {
						return history.push(
							`/facilities/${facility_id}/training/class/${training_class_id}/enrollment/${training_enrollment_id}`
						)
					}
					return history.push(`/clients/${household_id}/appointments/${_id}`)
				}}
				components={{
					Cell: (props) => (
						<MTableCell
							style={{
								borderBottom: 'none',
								padding: '16px 36px 16px 24px'
							}}
							{...props}
						/>
					)
				}}
				title="Appointments"
			/>
		</MuiThemeProvider>
	)
}
